import React, { useState, useEffect, useRef } from 'react';
import AddCustomerModal from '../../components/Modals/addCustomer';
import Select from 'react-select';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CardComponent from '../../components/cards/CardComponent';
import Header from '../../components/Header';
import Layout from '../../layout/Layout';
import { Textfield, TextfieldwithLabel } from '../../components/Buttons/Textfield';
import getAmountInWords from '../../components/numbertoWords';
import fetchData from '../../functions/fetchData';
import { getHeaders } from '../../utility/getHeader';
import { getUserName } from '../../functions/storageUtils';
import { getNextSetupDate } from '../../utils/setupDateUtils';

// Utility to fetch coresetting tax_type
async function fetchTaxType() {
  try {
    // coresetting table is usually a single row
    const res = await fetchData('coresetting', null, 'id', {});
    if (Array.isArray(res) && res.length > 0) {
      return res[0].tax_type ? res[0].tax_type.toLowerCase() : 'gst';
    }
    return 'gst'; // default fallback
  } catch (e) {
    return 'gst';
  }
}

export default function Quotation() {
  const itemNameRefs = useRef([])
  const [cart] = useState([])
  const [itemCodeInput, setItemCodeInput] = useState('')
  const [barcodeInput, setBarcodeInput] = useState('')
  const [barcode, setBarcode] = useState('')
  const [total, setTotal] = useState(0)
  const [paymentType, setPaymentType] = useState('Cash')
  const [companyProfile, setCompanyProfile] = useState(null)
  const navigate = useNavigate();
  
  // Check if user is cashier
  const userType = localStorage.getItem('usertype') || sessionStorage.getItem('usertype');
  const isCashier = userType === 'Cashier';
  
  // Navigate to dashboard function
  const navigateToDashboard = () => {
    if (isCashier) {
      navigate('/CashierDashboard');
    } else {
      navigate('/dashboard');
    }
  };
  // Tax type state
  const [taxType, setTaxType] = useState('gst');
  
  // Fetch company profile
  useEffect(() => {
    const fetchCompanyProfile = async () => {
      try {
        const response = await fetchData("company_profile", () => {}, "id", {});
        if (response && response.length > 0) {
          setCompanyProfile(response[0]);
        }
      } catch (error) {
        console.error('Error fetching company profile:', error);
      }
    };
    fetchCompanyProfile();
  }, []);
  
  // On mount, fetch tax type from coresetting
  useEffect(() => {
    (async () => {
      const ttype = await fetchTaxType();
      setTaxType(ttype);
    })();
  }, []);
  const [discountType, setDiscountType] = useState('percentage')
  const [discountValue, setDiscountValue] = useState(0)
  const [showCustomerModal, setShowCustomerModal] = useState(false)
  const [validUntil, setValidUntil] = useState(() => {
    // Default to 30 days from now
    const date = new Date();
    date.setDate(date.getDate() + 30);
    return date.toISOString().split('T')[0];
  })

  const [customerDetails, setCustomerDetails] = useState({
    name: '',
    phone: ''
  })
  const [showModal, setShowModal] = useState(false)
  const [modalInvoiceData, setModalInvoiceData] = useState({
    companyDetails: {},
    customerDetails: {},
    data: [],
    order_id: ''
  })
  const [itemRows, setItemRows] = useState([])
  const companyDetails = {
    name: 'Cloudnet Softwares',
    address: '123 Beach Road, Pattaya, Thailand',
    phone: '+66 987 654 321',
    email: 'info@cloudnetsoftwares.com'
  }

  const [editableRowIndex, setEditableRowIndex] = useState(null)
  const [customer, setCustomer] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    gst: '',
    deliveryPlace: ''
  })
  const [quotationSummary, setQuotationSummary] = useState({
    itemTotal: 0,
    discount: 0,
    subTotal: 0,
    tax: 0,
    roundOff: 0,
    grandTotal: 0
  })
  
  // Update quotation summary calculation
  useEffect(() => {
    let itemTotal = 0;
    let discount = 0;
    let taxValue = 0;
    let taxPercent = 0;
    let subTotal = 0;
    let roundOff = 0;
    let grandTotal = 0;
    let taxTypeLabel = taxType === 'vat' ? 'VAT' : 'GST';
    let taxPercentDisplay = '';

    if (itemRows.length > 0) {
      itemTotal = itemRows.reduce((sum, r) => sum + r.amount, 0);
      discount = itemRows.reduce((sum, r) => sum + r.discountValue, 0);
      subTotal = itemTotal - discount;
      
      // Calculate tax percent and value
      if (taxType === 'vat') {
        // VAT: use first nonzero VAT% as display
        const vatRows = itemRows.filter(r => r.vat > 0);
        taxPercent = vatRows.length > 0 ? vatRows[0].vat : 0;
        // If any item is taxIncluded, extract tax from netAmount, else add tax on top
        if (vatRows.length > 0 && vatRows[0].taxIncluded) {
          // Tax included: extract tax from netAmount
          taxValue = itemRows.reduce((sum, r) => sum + (r.taxIncluded ? (r.netAmount - (r.netAmount / (1 + (r.vat / 100)))) : 0), 0);
        } else {
          // Tax excluded: add tax on top
          taxValue = itemRows.reduce((sum, r) => sum + (!r.taxIncluded ? ((r.amount - r.discountValue) * (r.vat / 100)) : 0), 0);
        }
        taxPercentDisplay = `VAT (${taxPercent}%)`;
      } else {
        // GST: sum all GST fields
        let cgst = 0, sgst = 0, igst = 0;
        let cgstVal = 0, sgstVal = 0, igstVal = 0;
        itemRows.forEach(r => {
          if (r.cgst > 0) {
            cgst = r.cgst;
            cgstVal += r.taxIncluded ? (r.netAmount - (r.netAmount / (1 + (r.cgst / 100)))) : ((r.amount - r.discountValue) * (r.cgst / 100));
          }
          if (r.sgst > 0) {
            sgst = r.sgst;
            sgstVal += r.taxIncluded ? (r.netAmount - (r.netAmount / (1 + (r.sgst / 100)))) : ((r.amount - r.discountValue) * (r.sgst / 100));
          }
          if (r.igst > 0) {
            igst = r.igst;
            igstVal += r.taxIncluded ? (r.netAmount - (r.netAmount / (1 + (r.igst / 100)))) : ((r.amount - r.discountValue) * (r.igst / 100));
          }
        });
        taxPercent = cgst + sgst + igst;
        taxValue = cgstVal + sgstVal + igstVal;
        taxPercentDisplay = `GST (${taxPercent}%)`;
      }
      // Grand total: sum all net amounts
      grandTotal = itemRows.reduce((sum, r) => sum + r.netAmount, 0);
      grandTotal = Math.round(grandTotal);
      roundOff = grandTotal - itemRows.reduce((sum, r) => sum + r.netAmount, 0);
    }
    setQuotationSummary({
      itemTotal,
      discount,
      subTotal,
      tax: taxValue,
      taxPercent: taxPercentDisplay,
      roundOff,
      grandTotal
    });
  }, [itemRows, taxType])

  const [allItems, setAllItems] = useState([]) // from DB
  const [allCustomers, setAllCustomers] = useState([]) // from DB
  const [suggestions, setSuggestions] = useState({}) // {rowIndex: [items]}
  const [taxes, setTaxes] = useState([]); // All taxes from DB

  // Fetch data on mount
  useEffect(() => {
    fetchData('items', setAllItems, 'id', {});
    fetchData('customers', setAllCustomers, 'id', {});
    fetchData('taxes', setTaxes, 'id', {});
  }, []);

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...itemRows]
    const row = updatedRows[index]
    row[field] = value

    // If editing itemName, update suggestions
    if (field === 'itemName') {
      if (value && value.trim().length > 0) {
        const filtered = allItems.filter(
          item =>
            item.iname &&
            item.iname.toLowerCase().includes(value.trim().toLowerCase())
        )
        setSuggestions(prev => ({ ...prev, [index]: filtered }))
      } else {
        setSuggestions(prev => ({ ...prev, [index]: [] }))
      }
    }

    // Tax-included/excluded logic
    const included = row.taxIncluded;
    let rate = parseFloat(row.rate) || 0;
    let quantity = parseFloat(row.quantity) || 1;
    let discountPercent = parseFloat(row.discountPercent) || 0;
    let vat = taxType === 'vat' ? (parseFloat(row.vat) || 0) : 0;
    let cgst = taxType === 'gst' ? (parseFloat(row.cgst) || 0) : 0;
    let sgst = taxType === 'gst' ? (parseFloat(row.sgst) || 0) : 0;
    let igst = taxType === 'gst' ? (parseFloat(row.igst) || 0) : 0;
    let totalTaxPercent = taxType === 'vat' ? vat : (cgst + sgst + igst);
    let amount = 0, discountValue = 0, netAmount = 0;

    if (included) {
      // Tax is included in price: gross is the final price, discount is on gross
      let gross = rate * quantity;
      amount = gross; // Show the actual price paid (tax included)
      discountValue = gross * (discountPercent / 100);
      netAmount = gross - discountValue; // Final price after discount (still tax included)
    } else {
      // Tax is excluded: add tax after discount
      amount = rate * quantity;
      discountValue = amount * (discountPercent / 100);
      netAmount = (amount - discountValue) * (1 + (totalTaxPercent / 100));
    }

    row.amount = amount;
    row.discountValue = discountValue;
    row.netAmount = netAmount;

    setItemRows(updatedRows)
  }

  // Add global shortcut for adding new row and removing last row
  useEffect(() => {
    const handleShortcut = e => {
      const isCtrlEnter = e.ctrlKey && e.key === 'Enter'
      const isCmdEnter = e.metaKey && e.key === 'Enter'
      const isCtrlDel = e.ctrlKey && (e.key === 'Delete' || e.key === 'Del')
      if (isCtrlEnter || isCmdEnter) {
        e.preventDefault()
        setItemRows(prev => {
          const newRows = [
            ...prev,
            {
              id: Date.now(),
              itemName: '',
              description: '',
              rate: 0,
              quantity: 1,
              discountPercent: 0,
              cgst: 0,
              sgst: 0,
              igst: 0,
              vat: 0,
              amount: 0,
              discountValue: 0,
              netAmount: 0,
              taxIncluded: false
            }
          ]
          setEditableRowIndex(newRows.length - 1)
          return newRows
        })
      } else if (isCtrlDel) {
        e.preventDefault()
        setItemRows(prev => {
          if (prev.length === 0) return prev
          const newRows = prev.slice(0, -1)
          setEditableRowIndex(newRows.length - 1)
          return newRows
        })
      }
    }
    window.addEventListener('keydown', handleShortcut)
    return () => window.removeEventListener('keydown', handleShortcut)
  }, [])

  // Focus the react-select input when editableRowIndex changes to the last row
  useEffect(() => {
    if (
      editableRowIndex === itemRows.length - 1 &&
      itemNameRefs.current[editableRowIndex]
    ) {
      const select = itemNameRefs.current[editableRowIndex]
      if (select && select.focus) {
        select.focus()
      } else if (select && select.select && select.select.inputRef) {
        select.select.inputRef.focus()
      } else {
        const input = document.querySelector(
          `#itemName-${editableRowIndex} input`
        )
        if (input) input.focus()
      }
    }
  }, [editableRowIndex, itemRows.length])

  const handleItemSelect = (index, selectedItem) => {
    const updatedRows = [...itemRows]
    const row = updatedRows[index]
    
    row.itemName = selectedItem.iname || ''
    row.description = selectedItem.description || ''
    row.rate = parseFloat(selectedItem.rate) || 0
    row.quantity = 1
    row.discountPercent = 0
    
    // Set tax rates from item
    if (taxType === 'vat') {
      row.vat = parseFloat(selectedItem.vat) || 0
    } else {
      row.cgst = parseFloat(selectedItem.cgst) || 0
      row.sgst = parseFloat(selectedItem.sgst) || 0
      row.igst = parseFloat(selectedItem.igst) || 0
    }
    
    row.taxIncluded = selectedItem.tax_included === 1 || false
    
    // Calculate amounts
    const rate = row.rate
    const quantity = row.quantity
    const totalTaxPercent = taxType === 'vat' ? row.vat : (row.cgst + row.sgst + row.igst)
    
    if (row.taxIncluded) {
      row.amount = rate * quantity
      row.discountValue = 0
      row.netAmount = rate * quantity
    } else {
      row.amount = rate * quantity
      row.discountValue = 0
      row.netAmount = (rate * quantity) * (1 + (totalTaxPercent / 100))
    }
    
    setItemRows(updatedRows)
    setSuggestions(prev => ({ ...prev, [index]: [] }))
  }

  const addNewRow = (focusAfterAdd = false) => {
    const newRow = {
      id: Date.now(),
      itemName: '',
      description: '',
      rate: 0,
      quantity: 1,
      discountPercent: 0,
      cgst: 0,
      sgst: 0,
      igst: 0,
      vat: 0,
      amount: 0,
      discountValue: 0,
      netAmount: 0,
      taxIncluded: false
    }
    setItemRows(prev => [...prev, newRow])
    
    if (focusAfterAdd) {
      setEditableRowIndex(itemRows.length)
    }
  }

  const deleteRow = index => {
    if (itemRows.length === 1) {
      toast.warning('At least one row is required')
      return
    }
    const updatedRows = itemRows.filter((_, i) => i !== index)
    setItemRows(updatedRows)
    setEditableRowIndex(null)
  }

  const handleScan = async e => {
    e.preventDefault()
    const searchValue = itemCodeInput.trim() || barcodeInput.trim()
    if (!searchValue) {
      toast.error('Please enter item code or barcode')
      return
    }

    try {
      let item = null
      
      // Search by item_code if itemCodeInput has value
      if (itemCodeInput.trim()) {
        item = allItems.find(i => i.item_code === itemCodeInput.trim())
      }
      // Search by barcode if barcodeInput has value and no results from item_code
      else if (barcodeInput.trim()) {
        item = allItems.find(i => i.barcode === barcodeInput.trim())
      }
      
      if (item) {
        const existingRowIndex = itemRows.findIndex(row => row.itemName === item.iname)
        
        if (existingRowIndex >= 0) {
          const updatedRows = [...itemRows]
          updatedRows[existingRowIndex].quantity += 1
          handleRowChange(existingRowIndex, 'quantity', updatedRows[existingRowIndex].quantity)
          toast.success(`${item.iname} quantity increased`)
        } else {
          const newRow = {
            id: Date.now(),
            itemName: item.iname || '',
            description: item.description || '',
            rate: parseFloat(item.offerprice) || parseFloat(item.rate) || 0,
            quantity: 1,
            discountPercent: 0,
            cgst: parseFloat(item.cgst) || (parseFloat(item.tax) / 2) || 0,
            sgst: parseFloat(item.sgst) || (parseFloat(item.tax) / 2) || 0,
            igst: parseFloat(item.igst) || 0,
            vat: parseFloat(item.vat) || parseFloat(item.tax) || 0,
            amount: parseFloat(item.offerprice) || parseFloat(item.rate) || 0,
            discountValue: 0,
            netAmount: parseFloat(item.offerprice) || parseFloat(item.rate) || 0,
            taxIncluded: item.tax_included === 1 || false
          }
          setItemRows(prev => [...prev, newRow])
          toast.success(`${item.iname} added to quotation`)
        }
        setItemCodeInput('')
        setBarcodeInput('')
      } else {
        toast.error('Item not found')
      }
    } catch (error) {
      console.error('Error searching item:', error)
      toast.error('Error searching item')
    }
  }

  // Handler for item_code scan
  const handleItemCodeScan = async (code) => {
    if (!code) {
      toast.error('Please enter item code')
      return
    }

    try {
      const item = allItems.find(i => i.item_code === code.trim())
      
      if (item) {
        const existingRowIndex = itemRows.findIndex(row => row.itemName === item.iname)
        
        if (existingRowIndex >= 0) {
          const updatedRows = [...itemRows]
          updatedRows[existingRowIndex].quantity += 1
          handleRowChange(existingRowIndex, 'quantity', updatedRows[existingRowIndex].quantity)
          toast.success(`${item.iname} quantity increased`)
        } else {
          const newRow = {
            id: Date.now(),
            itemName: item.iname || '',
            description: item.description || '',
            rate: parseFloat(item.offerprice) || parseFloat(item.rate) || 0,
            quantity: 1,
            discountPercent: 0,
            cgst: parseFloat(item.cgst) || (parseFloat(item.tax) / 2) || 0,
            sgst: parseFloat(item.sgst) || (parseFloat(item.tax) / 2) || 0,
            igst: parseFloat(item.igst) || 0,
            vat: parseFloat(item.vat) || parseFloat(item.tax) || 0,
            amount: parseFloat(item.offerprice) || parseFloat(item.rate) || 0,
            discountValue: 0,
            netAmount: parseFloat(item.offerprice) || parseFloat(item.rate) || 0,
            taxIncluded: item.tax_included === 1 || false
          }
          setItemRows(prev => [...prev, newRow])
          toast.success(`${item.iname} added to quotation`)
        }
        setItemCodeInput('')
      } else {
        toast.error('Item not found with code: ' + code)
      }
    } catch (error) {
      console.error('Error searching item by code:', error)
      toast.error('Error searching item')
    }
  }

  // Handler for barcode scan
  const handleBarcodeScan = async (barcode) => {
    if (!barcode) {
      toast.error('Please enter barcode')
      return
    }

    try {
      const item = allItems.find(i => i.barcode === barcode.trim())
      
      if (item) {
        const existingRowIndex = itemRows.findIndex(row => row.itemName === item.iname)
        
        if (existingRowIndex >= 0) {
          const updatedRows = [...itemRows]
          updatedRows[existingRowIndex].quantity += 1
          handleRowChange(existingRowIndex, 'quantity', updatedRows[existingRowIndex].quantity)
          toast.success(`${item.iname} quantity increased`)
        } else {
          const newRow = {
            id: Date.now(),
            itemName: item.iname || '',
            description: item.description || '',
            rate: parseFloat(item.offerprice) || parseFloat(item.rate) || 0,
            quantity: 1,
            discountPercent: 0,
            cgst: parseFloat(item.cgst) || (parseFloat(item.tax) / 2) || 0,
            sgst: parseFloat(item.sgst) || (parseFloat(item.tax) / 2) || 0,
            igst: parseFloat(item.igst) || 0,
            vat: parseFloat(item.vat) || parseFloat(item.tax) || 0,
            amount: parseFloat(item.offerprice) || parseFloat(item.rate) || 0,
            discountValue: 0,
            netAmount: parseFloat(item.offerprice) || parseFloat(item.rate) || 0,
            taxIncluded: item.tax_included === 1 || false
          }
          setItemRows(prev => [...prev, newRow])
          toast.success(`${item.iname} added to quotation`)
        }
        setBarcodeInput('')
      } else {
        toast.error('Item not found with barcode: ' + barcode)
      }
    } catch (error) {
      console.error('Error searching item by barcode:', error)
      toast.error('Error searching item')
    }
  }

  // Modal state for Add New Customer
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
  const [newCustomer, setNewCustomer] = useState({
    name: '',
    contact: '',
    email: '',
    taxid: '',
    address: ''
  });

  const handleNewCustomerInput = e => {
    const { name, value } = e.target;
    setNewCustomer(prev => ({ ...prev, [name]: value }));
  };

  const handleAddCustomer = async e => {
    e.preventDefault();
    try {
      await axios.post(
        '/insertdata/customers',
        {
          name: newCustomer.name,
          contact: newCustomer.contact,
          email: newCustomer.email,
          taxid: newCustomer.taxid,
          address: newCustomer.address
        },
        getHeaders()
      );
      toast.success('Customer added successfully!');
      setShowAddCustomerModal(false);
      setNewCustomer({ name: '', contact: '', email: '', taxid: '', address: '' });
      // Optionally refresh customer list
      fetchData('customers', setAllCustomers, 'id', {});
    } catch (err) {
      toast.error('Error in adding customer');
    }
  };

  // Light color theme styles
  const lightTheme = {
    cardBackground: '#f8f9fa',
    headerBackground: '#e9ecef',
    tableHeader: '#dee2e6',
    primaryButton: '#0d6efd',
    successButton: '#198754',
    warningButton: '#ffc107',
    dangerButton: '#dc3545',
    infoButton: '#0dcaf0',
    textMuted: '#6c757d',
    borderColor: '#dee2e6'
  };

  const [lastSavedQuotation, setLastSavedQuotation] = useState(null);

  // Helper function to convert BLOB to base64
  const blobToBase64 = (blob, mimeType) => {
    if (!blob) return null;
    try {
      let uint8Array;
      if (blob.data) {
        uint8Array = new Uint8Array(blob.data);
      } else if (Array.isArray(blob)) {
        uint8Array = new Uint8Array(blob);
      } else {
        uint8Array = new Uint8Array(blob);
      }
      const base64 = btoa(String.fromCharCode.apply(null, uint8Array));
      return `data:${mimeType};base64,${base64}`;
    } catch (error) {
      console.error('Error converting BLOB to base64:', error);
      return null;
    }
  };

  // Print Quotation Function
  const printQuotation = () => {
    if (!lastSavedQuotation) {
      toast.error('No quotation data available for printing. Please save the quotation first.');
      return;
    }

    if (!companyProfile) {
      toast.error('Company profile not loaded. Please try again.');
      return;
    }

    // Use quotation_number for display, fallback to id if quotation_number is not available
    const quotationNumber = lastSavedQuotation.quotation_number || lastSavedQuotation.id || 'DRAFT';

    // Convert logo to base64 if available
    const logoSrc = companyProfile?.logo && companyProfile?.logo_type 
      ? blobToBase64(companyProfile.logo, companyProfile.logo_type) 
      : '/logo.png';

    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Quotation - ${quotationNumber}</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body {
            font-family: Arial, sans-serif;
            padding: 30px;
            background: white;
            font-size: 11px;
          }
          .container {
            max-width: 800px;
            margin: 0 auto;
            border: 1px solid #ddd;
          }
          .header-section {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 15px 20px;
            border-bottom: 1px solid #ddd;
          }
          .company-info {
            display: flex;
            gap: 15px;
            align-items: center;
          }
          .logo {
            width: 80px;
            height: 80px;
            object-fit: contain;
          }
          .company-details h2 {
            color: #FF6B35;
            font-size: 16px;
            margin-bottom: 3px;
          }
          .company-details p {
            font-size: 9px;
            color: #666;
            line-height: 1.3;
            margin: 2px 0;
          }
          .header-contact {
            text-align: right;
            font-size: 9px;
            color: #666;
            line-height: 1.5;
          }
          .title-bar {
            background: #FF6B35;
            color: black;
            text-align: center;
            padding: 8px;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 2px;
          }
          .info-section {
            display: flex;
            border-bottom: 1px solid #ddd;
          }
          .invoice-info, .customer-info {
            flex: 1;
            padding: 12px 20px;
          }
          .invoice-info {
            border-right: 1px solid #ddd;
          }
          .info-section h4 {
            font-size: 10px;
            color: #333;
            margin-bottom: 8px;
            padding-bottom: 3px;
            border-bottom: 1px solid #eee;
          }
          .info-row {
            display: flex;
            font-size: 9px;
            margin: 4px 0;
          }
          .info-label {
            font-weight: 600;
            min-width: 90px;
            color: #333;
          }
          .info-value {
            color: #555;
          }
          .items-table {
            width: 100%;
            border-collapse: collapse;
          }
          .items-table th {
            background: #666;
            color: white;
            padding: 8px 10px;
            text-align: left;
            font-size: 10px;
            font-weight: 600;
          }
          .items-table td {
            padding: 10px 10px;
            border-bottom: 1px solid #eee;
            font-size: 10px;
            vertical-align: top;
          }
          .items-table tr:last-child td {
            border-bottom: none;
          }
          .item-description {
            font-weight: 600;
            color: #0066cc;
            margin-bottom: 4px;
          }
          .item-details {
            font-size: 9px;
            color: #666;
            font-style: italic;
            line-height: 1.4;
            margin-top: 4px;
          }
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .watermark {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
            font-size: 120px;
            color: rgba(200, 200, 200, 0.15);
            font-weight: bold;
            z-index: -1;
            pointer-events: none;
          }
          .summary-section {
            border-top: 2px solid #333;
            padding: 0;
          }
          .summary-table {
            width: 100%;
            border-collapse: collapse;
          }
          .summary-row {
            display: flex;
            justify-content: flex-end;
            border-bottom: 1px solid #eee;
          }
          .summary-content {
            width: 300px;
            display: flex;
            justify-content: space-between;
            padding: 6px 20px;
            font-size: 10px;
          }
          .summary-label {
            color: #555;
          }
          .summary-value {
            font-weight: 600;
            color: #333;
          }
          .grand-total-row {
            background: #FF6B35;
            color: white;
            border: none;
          }
          .grand-total-row .summary-content {
            font-size: 12px;
            font-weight: bold;
          }
          .footer-section {
            display: flex;
            padding: 15px 20px;
            gap: 20px;
          }
          .terms-section {
            flex: 1;
          }
          .terms-section h4 {
            color: #FF6B35;
            font-size: 10px;
            margin-bottom: 5px;
          }
          .terms-section p {
            font-size: 8px;
            color: #666;
            line-height: 1.4;
            margin: 3px 0;
          }
          .bank-section {
            width: 280px;
            border: 1px solid #ddd;
            padding: 10px;
            background: #f9f9f9;
          }
          .bank-section h4 {
            color: #333;
            font-size: 10px;
            margin-bottom: 8px;
            padding-bottom: 3px;
            border-bottom: 1px solid #ddd;
          }
          .bank-row {
            display: flex;
            font-size: 9px;
            margin: 3px 0;
          }
          .bank-label {
            font-weight: 600;
            min-width: 90px;
            color: #333;
          }
          .bank-value {
            color: #555;
          }
          .signature-section {
            border-top: 1px solid #ddd;
            padding: 15px 20px;
            text-align: right;
          }
          .signature-box {
            display: inline-block;
            text-align: center;
            min-width: 200px;
          }
          .signature-line {
            border-top: 1px solid #333;
            margin-top: 50px;
            padding-top: 5px;
            font-size: 10px;
            font-weight: 600;
            color: #333;
          }
          .footer-note {
            text-align: center;
            padding: 8px;
            background: #f5f5f5;
            font-size: 8px;
            color: #666;
            font-style: italic;
          }
          @media print {
            body { padding: 0; }
            .container { border: none; }
          }
        </style>
      </head>
      <body>
        <div class="container">
          <!-- Header -->
          <div class="header-section">
            <div class="company-info">
              <img src="${logoSrc}" alt="Logo" class="logo" onerror="this.style.display='none'" />
              <div class="company-details">
                <h2>${companyProfile.name || 'Company Name'}</h2>
                <p><strong>Tax ID:</strong> ${companyProfile.tax_id || companyProfile.taxid || '0000000000000'}</p>
                <p>${companyProfile.address || ''}</p>
                <p>${companyProfile.city ? companyProfile.city + ', ' : ''}${companyProfile.state || ''} ${companyProfile.zipcode || ''}</p>
              </div>
            </div>
            <div class="header-contact">
              <p>📞 ${companyProfile.phone_number || ''}</p>
              <p>🌐 ${companyProfile.website || 'https://www.cloudnetsoftwares.com'}</p>
              <p>📧 ${companyProfile.email || 'cloudnetsoftwares@gmail.com'}</p>
            </div>
          </div>

          <!-- Title Bar -->
          <div class="title-bar">QUOTATION</div>

          <!-- Invoice & Customer Info -->
          <div class="info-section">
            <div class="invoice-info">
              <h4>📋 Quotation Information</h4>
              <div class="info-row">
                <span class="info-label">Quotation Number:</span>
                <span class="info-value">${quotationNumber}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Quotation Date:</span>
                <span class="info-value">${new Date(lastSavedQuotation.setup_date).toLocaleDateString('en-GB')}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Valid Until:</span>
                <span class="info-value">${new Date(lastSavedQuotation.valid_until).toLocaleDateString('en-GB')}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Payment Method:</span>
                <span class="info-value">${lastSavedQuotation.payment_mode || 'Cash'}</span>
              </div>
            </div>
            <div class="customer-info">
              <h4>👤 Customer Details</h4>
              <div class="info-row">
                <span class="info-label">Name:</span>
                <span class="info-value">${lastSavedQuotation.customer_name || 'Walk-in Customer'}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Phone:</span>
                <span class="info-value">${lastSavedQuotation.customer_phone || 'N/A'}</span>
              </div>
              ${lastSavedQuotation.customer_email ? `<div class="info-row">
                <span class="info-label">Email:</span>
                <span class="info-value">${lastSavedQuotation.customer_email}</span>
              </div>` : ''}
              ${lastSavedQuotation.customer_address ? `<div class="info-row">
                <span class="info-label">Address:</span>
                <span class="info-value">${lastSavedQuotation.customer_address}</span>
              </div>` : ''}
            </div>
          </div>

          <!-- Items Table -->
          <table class="items-table">
            <thead>
              <tr>
                <th width="5%" class="text-center">#</th>
                <th width="35%">Item Description</th>
                <th width="8%" class="text-center">Qty</th>
                <th width="12%" class="text-right">Rate</th>
                <th width="12%" class="text-right">Amount</th>
                <th width="10%" class="text-right">Disc%</th>
                <th width="18%" class="text-right">Net Amount</th>
              </tr>
            </thead>
            <tbody>
              ${lastSavedQuotation.items && lastSavedQuotation.items.length > 0 ? lastSavedQuotation.items.map((item, index) => `
                <tr>
                  <td class="text-center">${index + 1}</td>
                  <td>
                    <div class="item-description">${item.item_name || 'N/A'}</div>
                    ${item.description ? `<div class="item-details">${item.description}</div>` : ''}
                  </td>
                  <td class="text-center">${item.quantity || 0}</td>
                  <td class="text-right">฿ ${(item.rate || 0).toFixed(2)}</td>
                  <td class="text-right">฿ ${((item.rate || 0) * (item.quantity || 1)).toFixed(2)}</td>
                  <td class="text-right">0%</td>
                  <td class="text-right">฿ ${(item.total_price || 0).toFixed(2)}</td>
                </tr>
              `).join('') : '<tr><td colspan="7" class="text-center" style="padding: 20px;">No items found</td></tr>'}
            </tbody>
          </table>

          <!-- Page Break Space for Items -->
          <div style="min-height: 250px;"></div>

          <!-- Summary Section -->
          <div class="summary-section">
            <div class="summary-row">
              <div class="summary-content">
                <span class="summary-label">Subtotal:</span>
                <span class="summary-value">฿ ${(lastSavedQuotation.subtotal || 0).toFixed(2)}</span>
              </div>
            </div>
            <div class="summary-row">
              <div class="summary-content">
                <span class="summary-label">Discount:</span>
                <span class="summary-value">- ฿ ${((lastSavedQuotation.subtotal || 0) - (lastSavedQuotation.subtotal_afterdiscount || 0)).toFixed(2)}</span>
              </div>
            </div>
            <div class="summary-row grand-total-row">
              <div class="summary-content">
                <span class="summary-label">GRAND TOTAL:</span>
                <span class="summary-value">฿ ${(lastSavedQuotation.grand_total || 0).toFixed(2)}</span>
              </div>
            </div>
          </div>

          <!-- Footer Section with QR Code in Middle -->
          <div style="display: flex; padding: 15px 20px; gap: 15px; align-items: flex-start;">
            <div style="flex: 1;">
              <h4 style="color: #FF6B35; font-size: 10px; margin-bottom: 5px;">Terms & Conditions:</h4>
              ${companyProfile.terms_and_conditions ? companyProfile.terms_and_conditions.split('\n').map(line => `<p style="font-size: 8px; color: #666; line-height: 1.4; margin: 3px 0;">${line}</p>`).join('') : `
                <p style="font-size: 8px; color: #666; line-height: 1.4; margin: 3px 0;">• Payment is due upon receipt of invoice</p>
                <p style="font-size: 8px; color: #666; line-height: 1.4; margin: 3px 0;">• Late payments may incur additional charges</p>
                <p style="font-size: 8px; color: #666; line-height: 1.4; margin: 3px 0;">• Company liability limited to product value</p>
                <p style="font-size: 8px; color: #666; line-height: 1.4; margin: 3px 0;">• Customer responsible for order accuracy</p>
              `}
              <p style="margin-top: 8px; font-size: 8px; color: #666; font-style: italic;">For support, contact: ${companyProfile.email || 'support@cloudnetsoftwares.com'}</p>
            </div>
            
            ${companyProfile.qr_code && companyProfile.qr_code_type ? `
            <div style="text-align: center; padding: 0 15px;">
              <img src="${blobToBase64(companyProfile.qr_code, companyProfile.qr_code_type)}" 
                   alt="QR Code" 
                   style="max-width: 120px; max-height: 120px; object-fit: contain;" 
                   onerror="this.style.display='none'" />
            </div>
            ` : ''}
            
            <div style="width: 280px; border: 1px solid #ddd; padding: 10px; background: #f9f9f9;">
              <h4 style="color: #333; font-size: 10px; margin-bottom: 8px; padding-bottom: 3px; border-bottom: 1px solid #ddd;">💳 Bank Details</h4>
              <div style="display: flex; font-size: 9px; margin: 3px 0;">
                <span style="font-weight: 600; min-width: 90px; color: #333;">Bank Name:</span>
                <span style="color: #555;">${companyProfile.bank_name || 'Siam Commercial Bank'}</span>
              </div>
              <div style="display: flex; font-size: 9px; margin: 3px 0;">
                <span style="font-weight: 600; min-width: 90px; color: #333;">Account Name:</span>
                <span style="color: #555;">${companyProfile.account_name || companyProfile.name || 'Cloudnet Softwares Co., Ltd.'}</span>
              </div>
              <div style="display: flex; font-size: 9px; margin: 3px 0;">
                <span style="font-weight: 600; min-width: 90px; color: #333;">Account Number:</span>
                <span style="color: #555;">${companyProfile.account_number || '000-000-0000'}</span>
              </div>
              <div style="display: flex; font-size: 9px; margin: 3px 0;">
                <span style="font-weight: 600; min-width: 90px; color: #333;">Routing Number:</span>
                <span style="color: #555;">${companyProfile.routing_number || '0'}</span>
              </div>
              <div style="display: flex; font-size: 9px; margin: 3px 0;">
                <span style="font-weight: 600; min-width: 90px; color: #333;">SWIFT Code:</span>
                <span style="color: #555;">${companyProfile.swift_code || '0'}</span>
              </div>
            </div>
          </div>

          <!-- Signature -->
          <div class="signature-section">
            <div class="signature-box">
              <div class="signature-line">Authorized Signatory</div>
            </div>
          </div>

          <!-- Footer Note -->
          <div class="footer-note">
            This is a computer-generated quotation and does not require a physical signature.
          </div>
        </div>
      </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    
    // Auto print after a short delay
    setTimeout(() => {
      printWindow.print();
    }, 500);
  };

  const renderContent = () => (
    <div style={{ backgroundColor: '#ffffff', minHeight: '100vh' }}>
      <ToastContainer />
      
      {/* Dashboard Navigation Button - Only for cashiers */}
      {isCashier && (
        <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 1000 }}>
          <button
            className="btn"
            onClick={navigateToDashboard}
            style={{
              backgroundColor: lightTheme.primaryButton,
              color: 'white',
              padding: '10px 15px',
              fontSize: '14px',
              borderRadius: '25px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              border: 'none'
            }}
          >
            🏠 Dashboard
          </button>
        </div>
      )}

      <div className='row mb-3'>
        <div className='col-md-12'>
          <div style={{ 
            backgroundColor: '#f0f8ff', 
            border: '1px solid #d4e8f7',
            borderRadius: '10px',
            padding: '15px',
            marginBottom: '15px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
          }}>
            <div style={{ 
              backgroundColor: '#e3f2fd',
              padding: '8px 12px',
              borderRadius: '6px',
              marginBottom: '12px',
              borderLeft: '4px solid #2196f3'
            }}>
              <h6 className='m-0' style={{ color: '#1976d2', fontSize: '14px', fontWeight: '600' }}>👤 Customer Details</h6>
            </div>
            <div className='row'>
              {/* Name */}
              <div className='col-md-4 mb-2'>
                <label
                  htmlFor='customerName'
                  className='form-label'
                  style={{ fontSize: '11px', color: '#546e7a', fontWeight: '600', marginBottom: '4px' }}
                >
                  Customer Name
                </label>
                <Select
                  id='customerName'
                  name='customerName'
                  value={
                    customer.name
                      ? { label: customer.name, value: customer.name }
                      : null
                  }
                  onInputChange={(inputValue, { action }) => {
                    if (action === 'input-change') {
                      setCustomer({ ...customer, name: inputValue })
                    }
                  }}
                  onChange={selectedOption => {
                    if (!selectedOption) return
                    const selectedCustomer = allCustomers.find(
                      c => c.name === selectedOption.value
                    )
                    if (selectedCustomer) {
                      setCustomer({
                        name: selectedCustomer.name || '',
                        phone: selectedCustomer.contact || '',
                        email: selectedCustomer.email || '',
                        address: selectedCustomer.address || '',
                        gst: selectedCustomer.taxid || '',
                        deliveryPlace: selectedCustomer.deliveryPlace || '',
                        custid: selectedCustomer.id || ''
                      })
                    } else {
                      setCustomer({ ...customer, name: selectedOption.value })
                    }
                  }}
                  options={allCustomers.map(c => ({
                    label: c.name,
                    value: c.name
                  }))}
                  placeholder='Type or select customer name'
                  isClearable
                  openMenuOnClick={true}
                  menuPlacement='auto'
                  menuPortalTarget={
                    typeof window !== 'undefined' ? document.body : null
                  }
                  styles={{ 
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      minHeight: '32px',
                      height: '32px',
                      borderColor: '#b0d4f1',
                      backgroundColor: '#ffffff',
                      '&:hover': { borderColor: '#2196f3' }
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: '32px',
                      padding: '0 8px'
                    }),
                    input: (base) => ({
                      ...base,
                      margin: '0',
                      padding: '0'
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: '32px'
                    })
                  }}
                  filterOption={(option, inputValue) =>
                    option.label
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                />
              </div>

              {/* Phone */}
              <div className='col-md-4 mb-2'>
                <TextfieldwithLabel
                  id='customerPhone'
                  name='customerPhone'
                  value={customer.phone}
                  onChange={e =>
                    setCustomer({ ...customer, phone: e.target.value })
                  }
                  type='tel'
                  lable='Phone Number'
                  style={{
                    height: '32px',
                    fontSize: '13px',
                    padding: '6px 10px',
                    borderColor: '#b0d4f1',
                    backgroundColor: '#ffffff',
                    borderRadius: '4px'
                  }}
                />
              </div>

              {/* Email */}
              <div className='col-md-4 mb-2'>
                <TextfieldwithLabel
                  id='customerEmail'
                  name='customerEmail'
                  value={customer.email}
                  onChange={e =>
                    setCustomer({ ...customer, email: e.target.value })
                  }
                  type='email'
                  lable='Email'
                  style={{
                    height: '32px',
                    fontSize: '13px',
                    padding: '6px 10px',
                    borderColor: '#b0d4f1',
                    backgroundColor: '#ffffff',
                    borderRadius: '4px'
                  }}
                />
              </div>

              {/* Address */}
              <div className='col-md-6 mb-2'>
                <TextfieldwithLabel
                  id='customerAddress'
                  name='customerAddress'
                  value={customer.address}
                  onChange={e =>
                    setCustomer({ ...customer, address: e.target.value })
                  }
                  type='text'
                  lable='Address'
                  style={{
                    height: '32px',
                    fontSize: '13px',
                    padding: '6px 10px',
                    borderColor: '#b0d4f1',
                    backgroundColor: '#ffffff',
                    borderRadius: '4px'
                  }}
                />
              </div>

              {/* GST No */}
              <div className='col-md-3 mb-2'>
                <TextfieldwithLabel
                  id='customerGST'
                  name='customerGST'
                  value={customer.gst}
                  onChange={e =>
                    setCustomer({ ...customer, gst: e.target.value })
                  }
                  type='text'
                  lable='GST Number (Optional)'
                  style={{
                    height: '32px',
                    fontSize: '13px',
                    padding: '6px 10px',
                    borderColor: '#b0d4f1',
                    backgroundColor: '#ffffff',
                    borderRadius: '4px'
                  }}
                />
              </div>

              {/* Place of Delivery */}
              <div className='col-md-3 mb-2'>
                <TextfieldwithLabel
                  id='customerDeliveryPlace'
                  name='customerDeliveryPlace'
                  value={customer.deliveryPlace}
                  onChange={e =>
                    setCustomer({
                      ...customer,
                      deliveryPlace: e.target.value
                    })
                  }
                  type='text'
                  lable='Place of Delivery'
                  style={{
                    height: '32px',
                    fontSize: '13px',
                    padding: '6px 10px',
                    borderColor: '#b0d4f1',
                    backgroundColor: '#ffffff',
                    borderRadius: '4px'
                  }}
                />
              </div>
              <div className='col-md-12 mb-2'>
                <button 
                  className='btn'
                  onClick={() => setShowAddCustomerModal(true)}
                  style={{
                    backgroundColor: lightTheme.primaryButton,
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '8px 16px'
                  }}
                >
                  ➕ Add New Customer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Compact Scanner Section */}
      <div style={{ 
        backgroundColor: '#f8f9fa',
        border: '1px solid #dee2e6',
        borderRadius: '8px',
        padding: '15px',
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
      }}>
        <div className='row align-items-center g-2'>
          <div className='col-md-4'>
            <div className='input-group input-group-sm'>
              <span className='input-group-text bg-white' style={{ border: '1px solid #ced4da' }}>
                <i className='fas fa-barcode text-primary'></i>
              </span>
              <input
                className='form-control'
                id='itemCodeInput'
                value={itemCodeInput}
                onChange={e => setItemCodeInput(e.target.value)}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleItemCodeScan(itemCodeInput);
                  }
                }}
                type='text'
                placeholder='Scan Or Enter Item Code'
                style={{
                  border: '1px solid #ced4da',
                  fontSize: '14px',
                  height: '38px'
                }}
              />
            </div>
          </div>
          <div className='col-md-4'>
            <div className='input-group input-group-sm'>
              <span className='input-group-text bg-white' style={{ border: '1px solid #ced4da' }}>
                <i className='fas fa-qrcode text-success'></i>
              </span>
              <input
                className='form-control'
                id='barcodeInput'
                value={barcodeInput}
                onChange={e => setBarcodeInput(e.target.value)}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleBarcodeScan(barcodeInput);
                  }
                }}
                type='text'
                placeholder='Scan Or Enter Barcode'
                style={{
                  border: '1px solid #ced4da',
                  fontSize: '14px',
                  height: '38px'
                }}
              />
            </div>
          </div>
          <div className='col-md-4'>
            <button 
              className='btn btn-primary btn-sm w-100'
              onClick={() => {
                if (itemCodeInput) handleItemCodeScan(itemCodeInput);
                else if (barcodeInput) handleBarcodeScan(barcodeInput);
              }}
              style={{
                height: '38px',
                fontSize: '14px',
                fontWeight: '600',
                boxShadow: '0 2px 4px rgba(13,110,253,0.2)'
              }}
            >
              <i className='fas fa-search me-2'></i>Scan Now!
            </button>
          </div>
        </div>
      </div>

      {/* Items Table */}
      <div style={{ 
        backgroundColor: lightTheme.cardBackground, 
        border: `1px solid ${lightTheme.borderColor}`,
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <div style={{ 
          backgroundColor: lightTheme.headerBackground,
          padding: '10px 15px',
          borderRadius: '6px',
          marginBottom: '15px',
          borderLeft: `4px solid ${lightTheme.successButton}`
        }}>
          <h5 className='m-0' style={{ color: '#495057' }}>Add Items</h5>
        </div>
        <div className='table-responsive'>
          <table className='table' style={{ fontSize: '12px', backgroundColor: '#ffffff' }}>
            <thead style={{ backgroundColor: lightTheme.tableHeader }}>
              <tr style={{ fontSize: '12px' }}>
                <th style={{ fontSize: '11px', color: '#495057' }}>S.No</th>
                <th style={{ fontSize: '11px', color: '#495057' }}>Item Name</th>
                <th style={{ fontSize: '11px', color: '#495057' }}>Description</th>
                <th style={{ fontSize: '11px', color: '#495057' }}>Rate</th>
                <th style={{ fontSize: '11px', color: '#495057' }}>Qty</th>
                <th style={{ fontSize: '11px', color: '#495057' }}>Amount</th>
                <th style={{ fontSize: '11px', color: '#495057' }}>Disc%</th>
                <th style={{ fontSize: '11px', color: '#495057' }}>Disc Value</th>
                {taxType === 'vat' ? (
                  <th style={{ fontSize: '11px', color: '#495057' }}>VAT%</th>
                ) : (
                  <>
                    <th style={{ fontSize: '11px', color: '#495057' }}>CGST%</th>
                    <th style={{ fontSize: '11px', color: '#495057' }}>SGST%</th>
                    <th style={{ fontSize: '11px', color: '#495057' }}>IGST%</th>
                  </>
                )}
                <th style={{ fontSize: '11px', color: '#495057' }}>Net Amount</th>
                <th style={{ fontSize: '11px', color: '#495057' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {itemRows.map((row, index) => (
                <tr key={row.id} 
                    style={{ cursor: 'pointer', fontSize: '12px' }}
                    onClick={() => setEditableRowIndex(index)}
                >
                  <td>{index + 1}</td>

                  {/* Item Name */}
                  <td style={{ position: 'relative', minWidth: 220 }}>
                    {editableRowIndex === index ? (
                      <Select
                        id={`itemName-${index}`}
                        ref={el => (itemNameRefs.current[index] = el)}
                        value={
                          row.itemName
                            ? { label: row.itemName, value: row.itemName }
                            : null
                        }
                        onInputChange={(inputValue, { action }) => {
                          if (action === 'input-change')
                            handleRowChange(index, 'itemName', inputValue)
                        }}
                        onChange={(selectedOption, { action }) => {
                          if (!selectedOption) return
                          const selectedItem = allItems.find(
                            item => item.iname === selectedOption.value
                          )
                          if (selectedItem) {
                            handleItemSelect(index, selectedItem)
                            setTimeout(() => {
                              const descInput = document.getElementById(
                                `description-${index}`
                              )
                              if (descInput) descInput.focus()
                            }, 0)
                          }
                        }}
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            if (!row.itemName) return
                            setTimeout(() => {
                              if (
                                document.activeElement &&
                                document.activeElement.getAttribute('id') ===
                                `itemName-${index}`
                              ) {
                                addNewRow(true)
                              }
                            }, 0)
                          }
                        }}
                        options={allItems.map(item => ({
                          label: item.iname,
                          value: item.iname
                        }))}
                        placeholder='Type or select item name'
                        isClearable
                        openMenuOnClick={true}
                        menuPlacement='auto'
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({
                            ...base,
                            borderColor: lightTheme.borderColor,
                            '&:hover': { borderColor: lightTheme.primaryButton }
                          })
                        }}
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                    ) : (
                      <span style={{ color: row.itemName ? '#495057' : lightTheme.textMuted }}>
                        {row.itemName || 'Click to edit'}
                      </span>
                    )}
                  </td>

                  {/* Description */}
                  <td>
                    {editableRowIndex === index ? (
                      <Textfield
                        id={`description-${index}`}
                        value={row.description}
                        onChange={e =>
                          handleRowChange(
                            index,
                            'description',
                            e.target.value
                          )
                        }
                        type='text'
                        name='description'
                        style={{
                          borderColor: lightTheme.borderColor,
                          backgroundColor: '#ffffff'
                        }}
                      />
                    ) : (
                      <span style={{ color: '#495057' }}>{row.description}</span>
                    )}
                  </td>

                  {/* Rate */}
                  <td>
                    {editableRowIndex === index ? (
                      <Textfield
                        id={`rate-${index}`}
                        value={row.rate}
                        onChange={e =>
                          handleRowChange(
                            index,
                            'rate',
                            parseFloat(e.target.value) || 0
                          )
                        }
                        type='number'
                        name='rate'
                        style={{
                          borderColor: lightTheme.borderColor,
                          backgroundColor: '#ffffff'
                        }}
                      />
                    ) : (
                      <span style={{ color: '#495057' }}>{row.rate.toFixed(2)}</span>
                    )}
                  </td>

                  {/* Qty */}
                  <td>
                    {editableRowIndex === index ? (
                      <Textfield
                        id={`qty-${index}`}
                        value={row.quantity}
                        onChange={e =>
                          handleRowChange(
                            index,
                            'quantity',
                            parseInt(e.target.value) || 1
                          )
                        }
                        type='number'
                        name='quantity'
                        style={{
                          borderColor: lightTheme.borderColor,
                          backgroundColor: '#ffffff'
                        }}
                      />
                    ) : (
                      <span style={{ color: '#495057' }}>{row.quantity}</span>
                    )}
                  </td>

                  {/* Amount */}
                  <td style={{ color: '#495057' }}>{row.amount.toFixed(2)}</td>

                  {/* Disc% */}
                  <td>
                    {editableRowIndex === index ? (
                      <Textfield
                        id={`disc-${index}`}
                        value={row.discountPercent}
                        onChange={e =>
                          handleRowChange(
                            index,
                            'discountPercent',
                            parseFloat(e.target.value) || 0
                          )
                        }
                        type='number'
                        name='discountPercent'
                        style={{
                          borderColor: lightTheme.borderColor,
                          backgroundColor: '#ffffff'
                        }}
                      />
                    ) : (
                      <span style={{ color: '#495057' }}>{row.discountPercent}</span>
                    )}
                  </td>

                  {/* Disc Value */}
                  <td style={{ color: '#495057' }}>{row.discountValue.toFixed(2)}</td>

                  {/* VAT% or GST fields */}
                  {taxType === 'vat' ? (
                    <td>
                      {editableRowIndex === index ? (
                        <Textfield
                          id={`vat-${index}`}
                          value={row.vat}
                          onChange={e =>
                            handleRowChange(
                              index,
                              'vat',
                              parseFloat(e.target.value) || 0
                            )
                          }
                          type='number'
                          name='vat'
                          style={{
                            borderColor: lightTheme.borderColor,
                            backgroundColor: '#ffffff'
                          }}
                        />
                      ) : (
                        <span style={{ color: '#495057' }}>{row.vat}</span>
                      )}
                    </td>
                  ) : (
                    <>
                      <td>
                        {editableRowIndex === index ? (
                          <Textfield
                            id={`cgst-${index}`}
                            value={row.cgst}
                            onChange={e =>
                              handleRowChange(
                                index,
                                'cgst',
                                parseFloat(e.target.value) || 0
                              )
                            }
                            type='number'
                            name='cgst'
                            style={{
                              borderColor: lightTheme.borderColor,
                              backgroundColor: '#ffffff'
                            }}
                          />
                        ) : (
                          <span style={{ color: '#495057' }}>{row.cgst}</span>
                        )}
                      </td>
                      <td>
                        {editableRowIndex === index ? (
                          <Textfield
                            id={`sgst-${index}`}
                            value={row.sgst}
                            onChange={e =>
                              handleRowChange(
                                index,
                                'sgst',
                                parseFloat(e.target.value) || 0
                              )
                            }
                            type='number'
                            name='sgst'
                            style={{
                              borderColor: lightTheme.borderColor,
                              backgroundColor: '#ffffff'
                            }}
                          />
                        ) : (
                          <span style={{ color: '#495057' }}>{row.sgst}</span>
                        )}
                      </td>
                      <td>
                        {editableRowIndex === index ? (
                          <Textfield
                            id={`igst-${index}`}
                            value={row.igst}
                            onChange={e =>
                              handleRowChange(
                                index,
                                'igst',
                                parseFloat(e.target.value) || 0
                              )
                            }
                            type='number'
                            name='igst'
                            style={{
                              borderColor: lightTheme.borderColor,
                              backgroundColor: '#ffffff'
                            }}
                          />
                        ) : (
                          <span style={{ color: '#495057' }}>{row.igst}</span>
                        )}
                      </td>
                    </>
                  )}

                  {/* Net Amount */}
                  <td>
                    <span style={{ color: '#495057' }}>{row.netAmount.toFixed(2)}</span>
                    <br />
                    <small className={row.taxIncluded ? 'text-success' : 'text-warning'}>
                      {row.taxIncluded ? 'Tax Included' : 'Tax Excluded'}
                    </small>
                  </td>

                  {/* Delete Button */}
                  <td>
                    <button
                      className='btn btn-sm'
                      onClick={e => {
                        e.stopPropagation()
                        deleteRow(index)
                      }}
                      style={{
                        backgroundColor: lightTheme.dangerButton,
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '4px 8px'
                      }}
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button 
            className='btn mt-2'
            onClick={addNewRow}
            style={{
              backgroundColor: lightTheme.primaryButton,
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 16px'
            }}
          >
            ➕ Add Row
          </button>
        </div>
      </div>

      {/* Summary and Payment Section */}
      <div className='row mb-4'>
        <div className='col-md-6'>
          <div style={{ 
            backgroundColor: lightTheme.cardBackground, 
            border: `1px solid ${lightTheme.borderColor}`,
            borderRadius: '8px',
            padding: '20px'
          }}>
            <div className='d-flex align-items-center justify-content-between flex-wrap gap-2' style={{ minHeight: 60 }}>
              <div className='d-flex flex-column' style={{ minWidth: 220 }}>
                <label className='fw-semibold mb-1' style={{ color: '#495057' }}>Quotation Valid Until:</label>
                <input
                  type="date"
                  className='form-control'
                  value={validUntil}
                  onChange={e => setValidUntil(e.target.value)}
                  style={{
                    maxWidth: 200,
                    borderColor: lightTheme.borderColor,
                    backgroundColor: '#ffffff'
                  }}
                />
              </div>
              <div className='text-right' style={{ minWidth: 200 }}>
                <h5 className='mb-0' style={{ color: '#495057' }}>
                  Grand Total: <strong style={{ color: lightTheme.successButton }}>฿ {quotationSummary.grandTotal.toFixed(2)}</strong>
                </h5>
                <small style={{ color: lightTheme.textMuted }}>
                  {getAmountInWords(quotationSummary.grandTotal)}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-6'>
          <div style={{ 
            backgroundColor: lightTheme.cardBackground, 
            border: `1px solid ${lightTheme.borderColor}`,
            borderRadius: '8px',
            padding: '20px'
          }}>
            <div style={{ 
              backgroundColor: lightTheme.headerBackground,
              padding: '10px 15px',
              borderRadius: '6px',
              marginBottom: '15px',
              borderLeft: `4px solid ${lightTheme.successButton}`
            }}>
              <div className='d-flex justify-content-between align-items-center'>
                <h5 className='m-0' style={{ color: '#495057' }}>Quotation Summary</h5>
                <i className='fas fa-calculator fa-2x' style={{ color: lightTheme.textMuted }}></i>
              </div>
            </div>
            <div className='row gy-3 text-lg'>
              <div className='col-md-4'>
                <label className='fw-semibold' style={{ fontSize: '14px', color: '#495057' }}>Item Total</label>
                <div style={{ fontSize: '14px', color: '#495057' }}>
                  ฿ {quotationSummary.itemTotal.toFixed(2)}
                </div>
              </div>
              <div className='col-md-4'>
                <label className='fw-semibold' style={{ fontSize: '14px', color: '#495057' }}>Discount</label>
                <div style={{ fontSize: '14px', color: '#495057' }}>
                  ฿ {quotationSummary.discount.toFixed(2)}
                </div>
              </div>
              <div className='col-md-4'>
                <label className='fw-semibold' style={{ fontSize: '14px', color: '#495057' }}>Sub Total</label>
                <div style={{ fontSize: '14px', color: '#495057' }}>
                  ฿ {quotationSummary.subTotal.toFixed(2)}
                </div>
              </div>
              <div className='col-md-4'>
                <label className='fw-semibold' style={{ fontSize: '14px', color: '#495057' }}>Tax</label>
                <div style={{ fontSize: '14px', color: '#495057' }}>
                  {quotationSummary.taxPercent}: ฿ {quotationSummary.tax.toFixed(2)}
                </div>
              </div>
              <div className='col-md-4'>
                <label className='fw-semibold' style={{ fontSize: '14px', color: '#495057' }}>Round Off</label>
                <div style={{ fontSize: '14px', color: '#495057' }}>
                  ฿ {quotationSummary.roundOff.toFixed(2)}
                </div>
              </div>
              <div className='col-md-4'>
                <label className='fw-bold' style={{ fontSize: '14px', color: '#495057' }}>Grand Total</label>
                <div className='fw-bold' style={{ fontSize: '14px', color: lightTheme.successButton }}>
                  ฿ {quotationSummary.grandTotal.toFixed(2)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons Row */}
      <div className='row mb-4'>
        <div className='col-md-12'>
          <div style={{ 
            backgroundColor: lightTheme.cardBackground, 
            border: `1px solid ${lightTheme.borderColor}`,
            borderRadius: '8px',
            padding: '20px'
          }}>
            <div className='d-flex flex-wrap gap-2 justify-content-end'>
              <button
                className='btn'
                onClick={async () => {
                  // Validate
                  if (!customer.name || !customer.phone) {
                    toast.error('Please enter customer name and phone.');
                    return;
                  }
                  if (itemRows.length === 0) {
                    toast.error('Please add at least one item.');
                    return;
                  }
                  try {
                    const setupDate = await getNextSetupDate();
                    
                    // Fetch last quotation number and generate next one
                    const currentYear = new Date().getFullYear();
                    let nextQuotationNumber = `QUO-${currentYear}-0001`; // Default fallback for new year
                    
                    try {
                      const lastQuotationResponse = await axios.get('/getlatestrecord/quotations', getHeaders());
                      console.log('Last quotation response:', lastQuotationResponse.data);
                      
                      if (lastQuotationResponse.data && lastQuotationResponse.data.success) {
                        const responseData = lastQuotationResponse.data.data;
                        
                        // Use the next_quotation_number provided by backend
                        if (responseData && responseData.next_quotation_number) {
                          nextQuotationNumber = responseData.next_quotation_number;
                          console.log('Using backend generated quotation number:', nextQuotationNumber);
                        } else {
                          console.log('No next_quotation_number in response, using default');
                        }
                      } else if (lastQuotationResponse.data && lastQuotationResponse.data.message === 'No records found in the table') {
                        // No records found, use default
                        console.log('No quotations found in database, starting with:', nextQuotationNumber);
                      }
                    } catch (error) {
                      console.error('Error fetching last quotation number:', error);
                      // Use default if fetch fails - start with 0001 for current year
                      console.log('Error occurred, using default quotation number:', nextQuotationNumber);
                    }
                    
                    console.log('Next quotation number:', nextQuotationNumber);
                    
                    // Prepare quotation data
                    const quotationData = {
                      quotation_number: nextQuotationNumber,
                      customer_id: customer.custid || null,
                      customer_name: customer.name,
                      customer_phone: customer.phone,
                      customer_email: customer.email,
                      customer_address: customer.address,
                      customer_gst: customer.gst,
                      delivery_place: customer.deliveryPlace || '',
                      subtotal: quotationSummary.itemTotal || 0,
                      discount_type: discountType || 'amount',
                      discount_value: discountValue || 0,
                      subtotal_afterdiscount: quotationSummary.subTotal || 0,
                      tax: quotationSummary.tax || 0,
                      round_off: quotationSummary.roundOff || 0,
                      grand_total: quotationSummary.grandTotal || 0,
                      status: 'pending',
                      valid_until: validUntil,
                      setup_date: setupDate
                    };
                    
                    // Save quotation and get order_id
                    const res = await axios.post(
                      '/insertdata/quotations',
                      quotationData,
                      getHeaders()
                    );
                    
                    console.log('Quotation API Response:', res.data);
                    
                    const order_id = res.data.id || res.data.insertId;
                    const quotation_no = res.data.quotation_number || nextQuotationNumber;
                    
                    // Prepare quotation items - using order_id to match quotation_items table schema
           const quotationItems = itemRows.map(row => ({
                    order_id: order_id,
                    invoice_number: quotation_no,
                    table_number: customer.deliveryPlace || '',
                    item_name: row.itemName,
                    description: row.description || '',
                    quantity: row.quantity,
                    rate: row.rate || 0,
                    total_price: row.netAmount,
                    status: '1',
                    setup_date: setupDate
           }));
                    
                    console.log('quotationItems', quotationItems);

                    // Insert quotation items
                    await axios.post(
                      '/insertdatabulk/quotation_items',
                      { items: quotationItems },
                      getHeaders()
                    );
                    
                    toast.success(
                      `Quotation generated successfully. Quotation No: ${quotation_no || order_id}`
                    );
                    
                    // Store quotation data for printing
                    const quotationDataForPrint = {
                      id: order_id,
                      quotation_number: quotation_no,
                      setup_date: setupDate,
                      valid_until: validUntil,
                      customer_name: customer.name,
                      customer_phone: customer.phone,
                      customer_email: customer.email,
                      customer_address: customer.address,
                      customer_gst: customer.gst,
                      delivery_place: customer.deliveryPlace,
                      subtotal: quotationSummary.itemTotal,
                      subtotal_afterdiscount: quotationSummary.subTotal,
                      tax: quotationSummary.tax,
                      round_off: quotationSummary.roundOff,
                      grand_total: quotationSummary.grandTotal,
                      items: itemRows.map(row => ({
                        item_name: row.itemName,
                        description: row.description,
                        rate: row.rate,
                        quantity: row.quantity,
                        total_price: row.netAmount
                      }))
                    };
                    
                    console.log('Quotation data for printing:', quotationDataForPrint);
                    setLastSavedQuotation(quotationDataForPrint);
                    
                    // Auto print quotation after saving
                    // setTimeout(() => {
                    //   printQuotation();
                    // }, 1000);
                    
                    // Reset all data for next quotation
                    setItemRows([]);
                    setCustomer({
                      name: '',
                      phone: '',
                      email: '',
                      address: '',
                      gst: '',
                      deliveryPlace: ''
                    });
                    setDiscountValue(0);
                    setDiscountType('percentage');
                    // Reset valid until to 30 days from now
                    const newDate = new Date();
                    newDate.setDate(newDate.getDate() + 30);
                    setValidUntil(newDate.toISOString().split('T')[0]);
                    
                  } catch (err) {
                    console.error('Error saving quotation:', err);
                    toast.error('Error saving quotation.');
                  }
                }}
                style={{
                  backgroundColor: lightTheme.successButton,
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '10px 20px'
                }}
              >
                💾 Save Quotation
              </button>

              <button
                className='btn'
                onClick={() => {
                  setItemRows([])
                  setCustomer({
                    name: '',
                    phone: '',
                    email: '',
                    address: '',
                    gst: '',
                    deliveryPlace: ''
                  })
                  // Reset valid until to 30 days from now
                  const newDate = new Date();
                  newDate.setDate(newDate.getDate() + 30);
                  setValidUntil(newDate.toISOString().split('T')[0]);
                }}
                style={{
                  backgroundColor: lightTheme.dangerButton,
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '10px 20px'
                }}
              >
                ❌ Cancel Quotation
              </button>

              <button 
                className='btn'
                style={{
                  backgroundColor: lightTheme.warningButton,
                  color: '#495057',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '10px 20px'
                }}
              >
                🔄 Reset Quotation
              </button>

              <button
                className='btn'
                onClick={printQuotation}
                style={{
                  backgroundColor: lightTheme.primaryButton,
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '10px 20px'
                }}
              >
                🖨️ Print Quotation
              </button>
              
              <button
                className='btn'
                onClick={() => navigate('/quotation-history')}
                style={{
                  backgroundColor: '#9c88ff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '10px 20px'
                }}
              >
                📜 Quotation History
              </button>

              <button 
                className='btn'
                style={{
                  backgroundColor: lightTheme.infoButton,
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '10px 20px'
                }}
              >
                🧾 Templates
              </button>

              <button
                className='btn'
                onClick={() => {
                  // Convert quotation to sale
                  navigate('/sale/newsale', { 
                    state: { 
                      customer, 
                      itemRows, 
                      fromQuotation: true 
                    } 
                  });
                }}
                style={{
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '10px 20px'
                }}
              >
                💰 Convert to Sale
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Add New Customer Modal */}
      <AddCustomerModal
        show={showAddCustomerModal}
        onClose={() => setShowAddCustomerModal(false)}
        onSubmit={handleAddCustomer}
        newCustomer={newCustomer}
        handleInput={handleNewCustomerInput}
      />
    </div>
  );

  // Conditional rendering based on user type
  return isCashier ? (
    renderContent()
  ) : (
    <Layout>
      <Header title='Quotation System' />
      {renderContent()}
    </Layout>
  );
}
